// extracted by mini-css-extract-plugin
export default {"containerInner":"SquareContainer_containerInner__1DUvp","containerOuter":"SquareContainer_containerOuter__k0JXS","containerSquare":"SquareContainer_containerSquare__+2dQb"};